export interface Laptime {
  time: number;
}

export interface Session {
  id: string;
  trackId: string;
  laps: Lap[];
  fastestLap: number;
  position: number;
  competitors: number;
  userId: string;
  type: SessionType;
  date: Date;
  name: string;
  kartType: KartType;
  weight: number;
}

export enum KartType {
  NINE = "NINE",
  THIRTEEN = "THIRTEEN",
  KIDS = "KIDS",
}

export enum SessionType {
  RACE = "RACE",
  TRAINING = "TRAINING",
  QUALI = "QUALI",
}

export interface Lap {
  id: string;
  lapNumber: number;
  lapTime: number;
}
